"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.edit.title': 'Editar Pregunta',
};
